import React, { useEffect, useContext, useReducer, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import Row, { RowBetween, RowFlat } from '../../../components/Row'
import topOne from '../../../assets/top/top_one.svg'
import topTwo from '../../../assets/top/top_two.svg'
import topThree from '../../../assets/top/top_three.svg'
import top from '../../../assets/top/top.svg'
import Loading from './Loading'
import reducer, { initialState } from '../../../state/top/reducer'
import { getStakesRanks } from '../../../service/bakery'

// hooks
import { useActiveWeb3React } from '../../../hooks'

const TitleText = styled(Text)`
  font-family: Baloo Da;
  color: ${({theme}) => theme.bsText4};
`

const TopUl = styled.div`
  margin-top: 16px;
  width: 748px;
  height: auto;
  box-shadow: ${({theme}) => theme.darkMode ? 'none' : '0px 2px 10px rgba(171, 133, 115, 0.16)'};
  border-radius: 20px;
  font-family: Baloo Da;
  background: ${({theme}) => theme.bsBg10};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: auto;
    margin: 16px 0 0;
  `}
`
const TopRowBetween = styled(RowBetween)`
  position: relative;
  font-size: 16px;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  border-radius: 20px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding-left: 10px!important;
    padding-right: 10px!important;
  `}
`

const TopAddressLabel = styled.label`
  padding-left: 15px;
  word-break:break-all;
  width: 60%;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding-left: 0;
    margin: 0 10px;
    line-height: 15px;
    font-size: 14px;
    width: 45%;
  `}
`

const TopLabel = styled.label`
  margin-left: 9px;
  font-size: 18px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    font-size: 16px;
    margin-left: 5px;
  `}
`

const TopLi = styled(RowBetween)`
  margin: 0 46px;
  width: auto;
  height: 72px;
  border-bottom: 1px solid ${({theme}) => theme.bg3};
  color: ${({theme}) => theme.bsText2};
  &:last-child {
    border-bottom: 0px solid ${({theme}) => theme.bg3};
  }
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin: 0 10px;
  `}
`

const TopLiLabel = styled.label`
  margin-left: 9px;
  font-size: 18px;
  color: ${({theme}) => theme.bsText7};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    font-size: 16px;
    margin-left: 5px;
  `}
`
const TopRowFlat = styled(RowFlat)`
  padding-left: 10px;
  width: 20%;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding-left: 0;
    font-size: 16px;
    margin-left: 5px;
    width: 35%;
  `}
`

const SpecialImg = [topOne, topTwo, topThree]

let page = 1
let loading = false
let count = 0

interface TopStakeProps {
  lpTokenAddress: String,
  icon: String,
  name: String
}

const TopStakers: React.FC<TopStakeProps> = ({ lpTokenAddress, icon, name }) =>{
  const theme = useContext(ThemeContext)
  const { chainId } = useActiveWeb3React()
  const [loadingState, setLoadingState] = useState(false)
  const [state, dispatch] = useReducer(reducer, initialState)
  const LIMIT = 50
  const Special = [{
    padding: '0 46px',
    height: '81px',
    background: theme.bsBg11,
    color: theme.primaryText1,
    zIndex: 9
  }, {
    marginTop: '-41px',
    padding: '41px 46px 0',
    height: '113px',
    background: theme.bsBg12,
    color: theme.primaryText1,
    zIndex: 5
  }, {
    marginTop: '-41px',
    padding: '41px 46px 0',
    height: '113px',
    background: theme.bsBg13,
    color: theme.bsText7,
    zIndex: 3
  }]
  
  // const onScroll = () => {
  //   const offset =
  //     window.pageYOffset ||
  //     (document.documentElement && document.documentElement.scrollTop) ||
  //     document.body.scrollTop
  //   const scrollHeight = (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight
  //   const clientHeight = (document.documentElement && document.documentElement.clientHeight) || document.body.clientHeight
  //   if (offset === scrollHeight - clientHeight && count < 200) {
  //     getData()
  //   } else {
  //   }
  // }
  
  const getData = async () => {
    if (loading) return
    loading = true
    setLoadingState(true)
    let params = {
      poolAddress: lpTokenAddress,
      offset: (page - 1) * LIMIT,
      limit: LIMIT
    }
    getStakesRanks(chainId as number, params, (err: any, data: any) => {
      if (err) return
      if (data.code !== 0) return
      const dataAry = data.data.list || []
      loading = false
      setLoadingState(false)
      if (dataAry.length > 0) {
        count = count + dataAry.length
        if (page === 1) {
          dispatch({type: 'init', addData: dataAry})
        } else {
          dispatch({type: 'add', addData: dataAry})
        }
        page = page + 1
      }
    })
  }
  useEffect(() => {
    if (name.toLowerCase() === 'bread' || name.toLowerCase() === 'doughnut' || name.toLowerCase() === 'waffle') {
      page = 1
      loading = false
      count = 0
      getData()
    }
    // document.addEventListener('scroll', onScroll)
    // return () => document.removeEventListener('scroll', onScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId, name])
  
  if (name.toLowerCase() === 'bread' || name.toLowerCase() === 'doughnut' || name.toLowerCase() === 'waffle') {
    return (
      <div>
        <Row style={{width: 'auto', marginTop: '80px', justifyContent: 'center'}}>
          <img src={top} alt=""/>
          <TitleText fontSize={24} fontWeight={700} marginLeft="11px">Top Stakers</TitleText>
        </Row>
        <TopUl>
          {
            state.data.map((item, index) => 
              index > 2 ?
              <TopLi key={index}>
                <TopLiLabel>{item.rank}</TopLiLabel>
                <TopAddressLabel>{item.address}</TopAddressLabel>
                <TopRowFlat>
                  <img style={{width: '24px'}} src={'/images/bakery/icon_' + icon + '.svg'} alt=""/>
                  <TopLiLabel>{item.amount}</TopLiLabel>
                </TopRowFlat>
              </TopLi> :
              <TopRowBetween style={Special[index]} key={index}>
                <img src={SpecialImg[index]} alt=""/>
                <TopAddressLabel>{item.address}</TopAddressLabel>
                <TopRowFlat>
                  <img style={{width: '24px'}} src={'/images/bakery/icon_' + icon + '.svg'} alt=""/>
                  <TopLabel>{item.amount}</TopLabel>
                </TopRowFlat>
              </TopRowBetween>
            )
          }
        </TopUl>
        <Loading loadingState={loadingState}></Loading>
      </div>
    )
  } else {
    return (
      <div></div>
    )
  }
}
export default TopStakers
